<template>
  <div class="pl-toolbar-actions" aria-label="Call history actions">
    <div class="pl-toolbar-actions__stats" role="list">
      <div class="pl-chip" role="listitem">
        <v-icon icon="mdi-phone-log" class="pl-chip__icon" size="16" />
        <span class="pl-chip__value">{{ totalCalls }}</span>
        <span class="pl-chip__label">Calls</span>
      </div>

      <div class="pl-chip" role="listitem">
        <v-icon icon="mdi-phone-incoming" class="pl-chip__icon" size="16" />
        <span class="pl-chip__value pl-chip__value--mono">{{ toNumber }}</span>
        <span class="pl-chip__label">To number</span>
      </div>

      <div v-if="isSearchActive" class="pl-chip pl-chip--accent" role="listitem">
        <v-icon icon="mdi-magnify" class="pl-chip__icon" size="16" />
        <span class="pl-chip__value">Filtered</span>
      </div>
    </div>

    <div class="pl-toolbar-actions__buttons">
      <v-btn
        variant="outlined"
        size="small"
        class="pl-toolbar-btn pl-toolbar-btn--ghost"
        prepend-icon="mdi-refresh"
        :loading="loading"
        :disabled="!isSessionReady"
        @click="$emit('refresh')"
      >
        Refresh
      </v-btn>
    </div>
  </div>
</template>

<script setup>
defineOptions({ name: 'CallHistoryHeader' })

defineProps({
  totalCalls: { type: Number, default: 0 },
  toNumber: { type: String, default: '—' },
  loading: { type: Boolean, default: false },
  isSessionReady: { type: Boolean, default: false },
  isSearchActive: { type: Boolean, default: false },
})

defineEmits(['refresh'])
</script>
